import classnames from 'classnames';
import { Label, Text } from 'components';
import React, { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { cn } from 'utils';

interface Props {
  className?: string;
  inputClassName?: string;
  label?: string;
  labelTooltip?: string;
  type?: 'text' | 'password' | 'email' | 'number';
  value: any;
  subText?: string;
  setValue?: Dispatch<SetStateAction<any>>;
  placeholder?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  isDisabled?: boolean;
  errorMessage?: string | null;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void; 
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void; 
}

const Input = ({
  className,
  inputClassName,
  type = 'text',
  label,
  labelTooltip,
  value,
  setValue,
  subText,
  placeholder,
  onKeyDown,
  isDisabled,
  errorMessage,
  onChange,
  onBlur
}: Props) => {
  function onChangeInput(e: ChangeEvent<HTMLInputElement>) {
    if (onChange) {
      onChange(e);
    } else if (setValue) {
      if (type === 'number') {
        const value = e.target.value;
        if (value === '') {
          setValue('');
        } else {
          setValue(!Number.isNaN(e.target.valueAsNumber) ? e.target.valueAsNumber : 0);
        }
      } else {
        setValue(e.target.value);
      }
    }
  }

  return (
    <div className={classnames('flex w-full flex-col', className)}>
      {label && <Label label={label} htmlFor={label} labelTooltip={labelTooltip} />}
      <input
        disabled={isDisabled}
        id={label}
        type={type}
        className={cn(
          'border-border-primary',
          'relative h-8 w-full rounded border bg-transparent px-3 text-body2',
          inputClassName,
          { 'border-red-500': errorMessage }
        )}
        placeholder={placeholder}
        value={value}
        onBlur={onBlur}
        onChange={onChangeInput}
        onKeyDown={onKeyDown}
      />
      {errorMessage && (
        <Text className="mt-2 !text-red-500" size="body2" weight="regular">
          {errorMessage}
        </Text>
      )}
      {subText && (
        <Text className="mt-2" size="small" weight="medium" color="secondary">
          {subText}
        </Text>
      )}
    </div>
  );
};

export default Input;